import { stimulus } from "../javascripts/controllers/blog.js";
stimulus();
